import { Global, css } from '@emotion/react';

const GlobalStyles = () => (
  <Global
    styles={css`
      @font-face {
        font-family: 'Roboto';
        src: local('Roboto-Regular'),
          url('/dist/fonts/Roboto/roboto-regular.woff2') format('woff2'),
          url('/dist/fonts/Roboto/roboto-regular.woff') format('woff'),
          url('/dist/fonts/Roboto/roboto-regular.ttf') format('truetype');
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        src: local('Roboto-Bold'),
          url('/dist/fonts/Roboto/roboto-bold.woff2') format('woff2'),
          url('/dist/fonts/Roboto/roboto-bold.woff') format('woff'),
          url('/dist/fonts/Roboto/roboto-bold.ttf') format('truetype');
        font-weight: 700;
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        src: local('Roboto-Black'),
          url('/dist/fonts/Roboto/roboto-black.woff2') format('woff2'),
          url('/dist/fonts/Roboto/roboto-black.woff') format('woff'),
          url('/dist/fonts/Roboto/roboto-black.ttf') format('truetype');
        font-weight: 900;
        font-display: swap;
      }

      @font-face {
        font-family: 'Roboto';
        src: local('Roboto-Italic'),
          url('/dist/fonts/Roboto/roboto-italic.woff2') format('woff2'),
          url('/dist/fonts/Roboto/roboto-italic.woff') format('woff'),
          url('/dist/fonts/Roboto/roboto-italic.ttf') format('truetype');
        font-style: italic;
        font-display: swap;
      }

      a {
        text-decoration: none;
      }

      /*
       * Temporarily fixes the overflow of embed Youtube videos in articles
       */
      iframe {
        max-width: 100%;
      }

      /* Draft.js global styles
       * TODO: use html parser with custom components
       */
      .text-editor__image {
        max-width: 100%;
      }
    `}
  />
);

export default GlobalStyles;
